import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { ViewTeaWorkerDeployement } from './Pages';

export const ViewTeaWorkerDeployementRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={ViewTeaWorkerDeployement} />
    </Fragment>
)